import MenuIcon from '@mui/icons-material/Menu';
import {
  AppBar,
  Box,
  Button,
  Drawer,
  IconButton,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import logo from '../assets/thiagoobras.png'; // Importando a imagem do logo

const Header = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Switch between mobile and desktop

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setIsDrawerOpen(open);
  };

  const desktopNav = (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Button
        sx={{
          color: '#FFFFFF',
          fontWeight: 'bold',
          textTransform: 'none',
          marginRight: 2,
        }}
        href="#home"
      >
        Início
      </Button>
      <Button
        sx={{
          color: '#FFFFFF',
          fontWeight: 'bold',
          textTransform: 'none',
          marginRight: 2,
        }}
        href="#about"
      >
        Sobre
      </Button>
      <Button
        sx={{
          color: '#FFFFFF',
          fontWeight: 'bold',
          textTransform: 'none',
          marginRight: 2,
        }}
        href="#services"
      >
        Serviços
      </Button>
      <Button
        sx={{
          color: '#FFFFFF',
          fontWeight: 'bold',
          textTransform: 'none',
          border: '1px solid white',
          padding: '6px 12px',
        }}
        href="#contact"
      >
        Contato
      </Button>
    </Box>
  );

  const mobileDrawer = (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={toggleDrawer(false)}
    >
      <Box
        sx={{
          width: 250,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 2,
        }}
        role="presentation"
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
      >
        <Button
          sx={{
            width: '100%',
            marginBottom: 2,
            fontWeight: 'bold',
            textTransform: 'none',
          }}
          href="#home"
        >
          Início
        </Button>
        <Button
          sx={{
            width: '100%',
            marginBottom: 2,
            fontWeight: 'bold',
            textTransform: 'none',
          }}
          href="#about"
        >
          Sobre
        </Button>
        <Button
          sx={{
            width: '100%',
            marginBottom: 2,
            fontWeight: 'bold',
            textTransform: 'none',
          }}
          href="#services"
        >
          Serviços
        </Button>
        <Button
          sx={{
            width: '100%',
            fontWeight: 'bold',
            textTransform: 'none',
          }}
          href="#contact"
        >
          Contato
        </Button>
      </Box>
    </Drawer>
  );

  return (
    <>
      {/* AppBar */}
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: '#102820',
          padding: { xs: '0 16px', sm: '0 32px' },
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {/* Logo or Title */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={logo} // Usando a imagem importada
            alt="Thiago Silva Logo"
            style={{
              height: isMobile ? '80px' :'90px',
              cursor: 'pointer',
              position:'absolute',
              marginTop: 30,
              
            }} // Estilo do logo
          />
        </Box>


          {/* Responsive Navigation */}
          {isMobile ? (
            <IconButton
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            desktopNav
          )}
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      {isMobile && mobileDrawer}
    </>
  );
};

export default Header;